import { Component } from "react";
import { Button } from "@/components/ui/button";
import { RotateCcw, Home } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import i18n from "@/i18n";

/**
 * Route-level error boundary. Without it, any runtime error in a page unmounts
 * the whole React tree and leaves a blank screen. Shows a friendly, localized
 * fallback with a reload action instead.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Keep the error visible to operators (console / Sentry hook if wired).
    console.error("Matchium page error:", error, info?.componentStack || "");
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="matchium-shell flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center text-foreground">
        <BrandLogo markClass="w-12 h-12" textClass="text-2xl" />
        <h1 className="mt-8 text-3xl font-semibold tracking-tight sm:text-4xl">
          {i18n.t("interface.errorTitle")}
        </h1>
        <p className="mt-3 max-w-md text-muted-foreground">
          {i18n.t("interface.errorBody")}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button
            onClick={() => window.location.reload()}
            data-testid="error-reload"
            className="rounded-full"
          >
            <RotateCcw className="mr-1.5 h-4 w-4" />
            {i18n.t("interface.reload")}
          </Button>
          <Button
            variant="outline"
            onClick={() => { window.location.href = "/"; }}
            data-testid="error-home"
            className="rounded-full"
          >
            <Home className="mr-1.5 h-4 w-4" />
            {i18n.t("interface.backHome")}
          </Button>
        </div>
      </div>
    );
  }
}
